import { Button } from 'admin/components/atoms/Buttons';
import Labeled from 'admin/components/atoms/Labeled';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { QueryParamConfig, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { useAppSelector } from '~/javascripts/admin/hooks/useApp';
import Select from '../../../atoms/Select';
import LabeledSelect from '../../../molecules/LabeledSelect';

type ExchangesQueryParamConfig = typeof queryParamConfigs;
export type ExchangesQueryParams = {
  [key in keyof ExchangesQueryParamConfig]: ExchangesQueryParamConfig[key] extends QueryParamConfig<
    unknown,
    infer T
  >
    ? T
    : never;
};

const queryParamConfigs = {
  private_money_id: withDefault(StringParam, ''),
};

const Wrapper = styled.div`
  ${Button} {
    margin: 5px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${Labeled} {
    display: flex;
    margin: 10px;
    align-items: center;
    gap: 10px;
  }

  ${Select as any} {
    width: 300px;
  }
`;

const LabelText = styled.div``;

const FilterForm = ({ applyFilters }: { applyFilters: (params: ExchangesQueryParams) => void }) => {
  const user = useAppSelector((state) => state.user);

  const privateMoneyOptions = (user.isServiceUser() ? user.moneys() : user.issuedMoneys()).map(
    (money) => ({ label: money.name, value: money })
  );

  const [query, setQuery] = useQueryParams({
    ...queryParamConfigs,
  });

  useEffect(() => {
    applyFilters({
      ...query,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <Wrapper>
      <FormWrapper>
        <LabeledSelect
          labelText={<LabelText>マネー名</LabelText>}
          options={privateMoneyOptions}
          value={privateMoneyOptions.find((opt) => opt.value.id === query.private_money_id)}
          isMulti={false}
          onChange={(opt) => setQuery({ private_money_id: opt?.value.id ?? '' })}
          isClearable
        />
      </FormWrapper>
    </Wrapper>
  );
};

export default FilterForm;
